import { Attachment } from "..";

export const getAttachmentsByType = (attachments: Attachment[]) => {
  const images = attachments.filter(
    (attachment) => attachment.type === "PHOTO"
  );

  const files = attachments.filter(
    (attachments) => attachments.type === "FILE"
  );

  const videos = attachments.filter(
    (attachments) => attachments.type === "VIDEO"
  );

  return { images, files, videos };
};
